import React, { memo, useState, useCallback, PropsWithChildren, useEffect } from 'react';
import { Layout, Typography, Space, Dropdown, MenuProps, Modal } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { CaretDownOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import RouteMenu from './RouteMenu';
import LogoImage from '../../../../../public/images/logo.png';
import { actions as mainActions } from '@/modules/main';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import RouteTabs from '@/components/RouteTabs';
import { AllState } from '@/state';
import { MenuItemType } from './RouteMenu/type';
import Icon, { IconClass } from '@/components/Icon';
import { MenuType } from '../../type';
import { ItemType } from 'antd/es/menu/interface';

const { Header, Sider, Content } = Layout;

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: string,
  children?: MenuItemType[],
  type?: 'group',
): MenuItemType {
  return {
    key,
    icon: icon ? <Icon type={icon as IconClass} /> : undefined,
    children,
    label,
    type,
  } as MenuItemType;
}

interface Props extends PropsWithChildren {
  blacklist?: string[];
}

function Index(props: Props) {
  const { children, blacklist = [] } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { userInfo, menus, menuLoading } = useSelector(
    (state: AllState) => ({
      userInfo: state.main.userInfo,
      menus: state.main.menus,
      menuLoading: state['@loading'].menu,
    }),
    shallowEqual,
  );

  const menuItems = menus
    ?.filter((_) => _.children?.length)
    ?.map((_) =>
      _.hidden
        ? null
        : getItem(
            _.name,
            _.url,
            _.icon,
            _.type !== MenuType.Button ? _.children?.map((_) => getItem(_.name, _.url, _.icon)) : undefined,
          ),
    )
    .filter((_) => _ !== null) as ItemType[];

  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (menus?.length) {
      dispatch(mainActions.pushTabItem(pathname));
    }
  }, [menus]);

  const toggleCollapsed = () => setCollapsed(!collapsed);

  const handleChange = useCallback(
    (value: string) => {
      history.push(value);
    },
    [history],
  );

  const items: MenuProps['items'] = [
    {
      key: '0',
      label: '退出登录',
      onClick: () => {
        modal.confirm({
          title: '退出登录',
          content: '确定退出登录吗？',
          onOk: () => {
            dispatch(mainActions.logout());
          },
        });
      },
    },
  ];

  return blacklist.includes(pathname) ? (
    children
  ) : (
    <Layout className='w-screen h-screen'>
      <Header className='flex justify-between items-center'>
        <img className='h-[50px] cursor-pointer' src={LogoImage} onClick={() => history.push('/')} />
        <Dropdown menu={{ items }}>
          <Space size={8} className='flex justify-center items-center cursor-pointer'>
            <Icon type={IconClass.USER} className='text-[#838383]' onClick={() => history.push('/')} />
            <Typography.Text className='text-white opacity-60'>{userInfo?.username}</Typography.Text>
            <CaretDownOutlined className='text-white opacity-60' />
          </Space>
        </Dropdown>
      </Header>
      <Layout>
        <Sider
          width={192}
          className='shadow-md z-[1] relative border-r border-r-[#DCDFE6]'
          trigger={null}
          collapsible
          collapsed={collapsed}
          collapsedWidth={56}
          style={{ boxShadow: 'none' }}
        >
          <div className='flex flex-col h-full'>
            <RouteMenu
              loading={!!menuLoading}
              mode={collapsed ? undefined : 'inline'}
              value={pathname}
              onChange={handleChange}
              items={menuItems}
              rootClassName='flex-1 h-full !border-none'
            />
            <div className='mb-6 mx-6 cursor-pointer' onClick={toggleCollapsed}>
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
          </div>
        </Sider>
        <Layout>
          <RouteTabs />
          <Content>{children}</Content>
        </Layout>
      </Layout>
      {contextHolder}
    </Layout>
  );
}

export default memo(Index);
